import React, { useState } from 'react';
import axios from 'axios';
import { getApiBase } from '../utils/api';

export default function SSOEmailConfirmation({ onSuccess, onCancel }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async event => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const { data } = await axios.post(`${getApiBase()}/auth/sso/confirm-email`, { code }, { withCredentials: true });
      await onSuccess(data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Unable to confirm your email. Please try again.');
    } finally { setBusy(false); }
  };
  return <form onSubmit={submit} className="space-y-4 text-left">
    <h2 className="text-2xl font-bold">Confirm your email</h2>
    <p>Enter the six-digit code sent to your account email to finish signing in with this provider. You only need to do this once for this sign-in method.</p>
    <label className="block" htmlFor="sso-confirmation-code">Confirmation code</label>
    <input id="sso-confirmation-code" className="w-full border rounded p-2" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={code} onChange={event => setCode(event.target.value)} />
    {error && <p role="alert" className="text-red-600">{error}</p>}
    <button className="w-full bg-blue-600 text-white rounded p-2" disabled={busy} type="submit">{busy ? 'Confirming…' : 'Confirm and sign in'}</button>
    <button className="w-full p-2" type="button" onClick={onCancel}>Back to sign-in</button>
  </form>;
}
